import React, { useState, useContext } from "react";
import { Dropdown, Button, Col } from "react-bootstrap";
import { IconBellFilled } from "@tabler/icons-react";
import UserContext from "../../../contexts/UserContext";
import styled from "styled-components";
import logo from "../../../images/atendflow-logo.png";
import logo_symbol from "../../../images/atendflow-icon.png"; // Importação do logo symbol
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logout } from "../../../services/LoginServices";
import { Hash } from "../../../helpers/Helpers";

// Container principal que engloba o sidebar e o conteúdo
const MainContainer = styled.div`
  display: flex;
`;

// Sidebar que contém o menu lateral
const Sidebar = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  background-color: #fff;
  color: white;
  width: ${(props) => (props.expanded ? "250px" : "70px")};
  transition: width 0.3s ease;
  overflow-x: hidden;
  z-index: 1002;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

// Logo container
const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  background-color: #fff;
  height: 60px;
  overflow: hidden;
`;

// Logo completo
const LogoFull = styled.img`
  margin-top: 10px;
  width: 175px;
  opacity: ${(props) => (props.expanded ? 1 : 0)};
  transition: opacity 0.3s ease;
  display: ${(props) => (props.expanded ? "block" : "none")};
`;

// Logo símbolo
const LogoSymbol = styled.img`
  margin-top: 10px;
  width: 40px;
  opacity: ${(props) => (props.expanded ? 0 : 1)};
  transition: opacity 0.3s ease;
  display: ${(props) => (props.expanded ? "none" : "block")};
`;

// Header para perfil de usuário
const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fff;
  color: white;
  padding: 10px 20px;
  height: 60px;
  position: fixed;
  width: ${(props) => `calc(100% - ${props.sidebarWidth}px)`};
  top: 0;
  right: 0;
  z-index: 1001;
  transition: width 0.3s ease;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
`;

// Seção do menu
const MenuSection = styled.div`
  margin: 20px 0;
`;

// Cabeçalho da seção do menu
const MenuSectionHeader = styled.div`
  padding: ${(props) => (props.expanded ? "7.5px 10px" : "12px 0")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.expanded ? "space-between" : "center")};
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #1e293b;
  background-color: ${(props) =>
    props.active ? "var(--primary)" : "rgba(255, 255, 255, 0.05)"};
  width: 95%;
  margin: auto;
  border-radius: 20px;

  &:hover {
    background-color: var(--primary);
    color: #fff;
  }

  .section-title {
    display: ${(props) => (props.expanded ? "flex" : "none")};
    align-items: center;
    white-space: nowrap;
    margin-left: 10px;
    color: ${(props) => (props.active ? "#fff" : "inherit")};
  }

  .section-icon {
    font-size: 20px;

    i {
      color: ${(props) => (props.active ? "#fff" : "inherit")};
    }
  }

  &:hover i {
    color: #fff;
  }

  .toggle-icon {
    display: ${(props) => (props.expanded ? "block" : "none")};
    color: ${(props) => (props.active ? "#fff" : "var(--primary)")};
  }
`;

// Container para submenus
const SubMenuContainer = styled.div`
  transition: max-height 0.3s ease-in-out;
  overflow: hidden;
`;

// Item do menu
const MenuItem = styled.div`
  padding: ${(props) => (props.expanded ? "7.5px 10px" : "10px 0")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.expanded ? "flex-start" : "center")};
  background-color: ${(props) =>
    props.active ? "var(--primary)" : "transparent"};
  color: ${(props) => (props.active ? "#fff" : "#1e293b")};
  position: relative;
  width: 95%;
  margin: 10px auto;
  border-radius: 20px;

  &:hover {
    background-color: var(--primary);
    color: #fff;
  }

  i {
    font-size: 20px;
    min-width: ${(props) => (props.expanded ? "20px" : "100%")};
    text-align: ${(props) => (props.expanded ? "left" : "center")};
    color: ${(props) => (props.active ? "#fff" : "inherit")};
  }

  &:hover i {
    color: #fff;
  }

  span {
    margin-left: ${(props) => (props.expanded ? "10px" : "0")};
    display: ${(props) => (props.expanded ? "block" : "none")};
    white-space: nowrap;
  }
`;

// Item do submenu
const SubMenuItem = styled(MenuItem)`
  padding-left: ${(props) => (props.expanded ? "35px" : "0")};
`;

const Header = () => {
  const { bottyData, user } = useContext(UserContext);
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarWidth = expanded ? 250 : 70;

  // Estado para controlar seções expandidas
  const [expandedSections, setExpandedSections] = useState({
    comunicacao: true,
    gerenciamento: false,
    inteligencia: false,
    configuracoes: false,
  });

  // Estado para controlar qual seção está visualmente ativa
  const [activeSection, setActiveSection] = useState("comunicacao");

  const superuser = {
    1: "Admin",
    2: "Manager",
    3: "Staff",
  };

  // Expandir o menu ao passar o mouse
  const handleMouseEnter = () => {
    setExpanded(true);
  };

  // Recolher o menu ao retirar o mouse
  const handleMouseLeave = () => {
    setExpanded(false);
  };

  const handleClick = (path) => {
    navigate(path);
  };

  // Função modificada para fechar outras seções quando uma for aberta
  const toggleSection = (section) => {
    setExpandedSections((prev) => {
      const isCurrentlyExpanded = prev[section];

      if (isCurrentlyExpanded) {
        // Se a seção atual estiver expandida, apenas feche ela
        return {
          ...prev,
          [section]: false,
        };
      } else {
        // Se a seção atual estiver fechada, feche todas e abra apenas a clicada
        const newState = {};
        Object.keys(prev).forEach((key) => {
          newState[key] = key === section;
        });
        return newState;
      }
    });
  };

  const currentPath = location.pathname;

  // Verifica se uma seção está ativa baseada nos caminhos atuais
  const isSectionActive = (section) => {
    switch (section) {
      case "comunicacao":
        return (
          currentPath.includes("/chat") ||
          currentPath.includes("/crm") ||
          currentPath.includes("/campaigns")
        );
      case "gerenciamento":
        return (
          currentPath.includes("/calendar") ||
          currentPath.includes("/templates") ||
          currentPath.includes("/automations")
        );
      case "inteligencia":
        return currentPath.includes("/agents");
      case "configuracoes":
        return (
          currentPath.includes("/whatsapp") ||
          currentPath.includes("/business-settings")
        );
      default:
        return false;
    }
  };

  return (
    <MainContainer>
      <Sidebar
        expanded={expanded}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <LogoContainer>
          <LogoSymbol src={logo_symbol} alt="logo symbol" expanded={expanded} />
          <LogoFull src={logo} alt="logo" expanded={expanded} />
        </LogoContainer>
        {!user.is_superuser ? (
          <MenuItem
            expanded={expanded}
            active={currentPath.includes("/calendar")}
            onClick={() => handleClick("/calendar")}
          >
            <i className="las la-calendar" />
            <span>Agenda</span>
          </MenuItem>
        ) : (
          <>
            <MenuSection>
              <MenuItem
                expanded={expanded}
                active={currentPath === "/"}
                onClick={() => handleClick("/")}
              >
                <i className="las la-home" />
                <span>Início</span>
              </MenuItem>
            </MenuSection>
            {/* Seção de Comunicação */}
            <MenuSection>
              <MenuSectionHeader
                expanded={expanded}
                active={isSectionActive("comunicacao")}
                onClick={() => toggleSection("comunicacao")}
              >
                <div className="d-flex">
                  <div className="section-icon">
                    <i className="las la-comment" />
                  </div>
                  <div className="section-title">
                    <span>Comunicação</span>
                  </div>
                </div>
                <i
                  className={`las ${
                    expandedSections.comunicacao
                      ? "la-angle-down"
                      : "la-angle-right"
                  } toggle-icon`}
                />
              </MenuSectionHeader>

              {expandedSections.comunicacao && (
                <SubMenuContainer>
                  {bottyData?.uid && (
                    <SubMenuItem
                      expanded={expanded}
                      active={currentPath.includes("/chat")}
                      onClick={() => handleClick("/chat")}
                    >
                      <i className="las la-comment-dots" />
                      <span>Chat</span>
                    </SubMenuItem>
                  )}

                  {/* <SubMenuItem
                    expanded={expanded}
                    active={currentPath.includes("/campaigns")}
                    onClick={() => handleClick("/campaigns")}
                  >
                    <i className="las la-bullhorn" />
                    <span>Campanhas</span>
                  </SubMenuItem> */}
                </SubMenuContainer>
              )}
            </MenuSection>

            {/* Seção de Gerenciamento */}
            <MenuSection>
              <MenuSectionHeader
                expanded={expanded}
                active={isSectionActive("gerenciamento")}
                onClick={() => toggleSection("gerenciamento")}
              >
                <div className="d-flex">
                  <div className="section-icon">
                    <i className="las la-tasks" />
                  </div>
                  <div className="section-title">
                    <span>Gestão</span>
                  </div>
                </div>
                <i
                  className={`las ${
                    expandedSections.gerenciamento
                      ? "la-angle-down"
                      : "la-angle-right"
                  } toggle-icon`}
                />
              </MenuSectionHeader>

              {expandedSections.gerenciamento && (
                <SubMenuContainer>
                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath.includes("/calendar")}
                    onClick={() => handleClick("/calendar")}
                  >
                    <i className="las la-calendar" />
                    <span>Agenda</span>
                  </SubMenuItem>
                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath.includes("/customers")}
                    onClick={() => handleClick("/customers")}
                  >
                    <i className="las la-user-tie" />
                    <span>Clientes</span>
                  </SubMenuItem>
                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath.includes("/crm")}
                    onClick={() => handleClick("/crm")}
                  >
                    <i className="las la-filter" />
                    <span>CRM</span>
                  </SubMenuItem>
                  {bottyData?.uid && (
                    <>
                      <SubMenuItem
                        expanded={expanded}
                        active={currentPath.includes("/templates")}
                        onClick={() => handleClick("/templates")}
                      >
                        <i className="las la-file-alt" />
                        <span>Templates</span>
                      </SubMenuItem>

                      <SubMenuItem
                        expanded={expanded}
                        active={currentPath.includes("/automations")}
                        onClick={() => handleClick("/automations")}
                      >
                        <i className="las la-share-alt" />
                        <span>Automações</span>
                      </SubMenuItem>
                    </>
                  )}

                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath.includes("/users")}
                    onClick={() => handleClick("/users")}
                  >
                    <i className="las la-users" />
                    <span>Usuários</span>
                  </SubMenuItem>
                </SubMenuContainer>
              )}
            </MenuSection>

            {/* Seção de Inteligência */}
            <MenuSection>
              <MenuSectionHeader
                expanded={expanded}
                active={isSectionActive("inteligencia")}
                onClick={() => toggleSection("inteligencia")}
              >
                <div className="d-flex">
                  <div className="section-icon">
                    <i className="las la-brain" />
                  </div>
                  <div className="section-title">
                    <span>Inteligência</span>
                  </div>
                </div>
                <i
                  className={`las ${
                    expandedSections.inteligencia
                      ? "la-angle-down"
                      : "la-angle-right"
                  } toggle-icon`}
                />
              </MenuSectionHeader>

              {expandedSections.inteligencia && (
                <SubMenuContainer>
                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath.includes("/agents")}
                    onClick={() => handleClick("/agents")}
                  >
                    <i className="las la-brain" />
                    <span>Agentes</span>
                  </SubMenuItem>
                </SubMenuContainer>
              )}
            </MenuSection>

            {/* Configurações */}
            <MenuSection>
              <MenuSectionHeader
                expanded={expanded}
                active={isSectionActive("configuracoes")}
                onClick={() => toggleSection("configuracoes")}
              >
                <div className="d-flex">
                  <div className="section-icon">
                    <i className="las la-cog" />
                  </div>
                  <div className="section-title">
                    <span>Configurações</span>
                  </div>
                </div>
                <i
                  className={`las ${
                    expandedSections.configuracoes
                      ? "la-angle-down"
                      : "la-angle-right"
                  } toggle-icon`}
                />
              </MenuSectionHeader>

              {expandedSections.configuracoes && (
                <SubMenuContainer>
                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath === "/whatsapp"}
                    onClick={() => handleClick("/whatsapp")}
                  >
                    <i className="lab la-whatsapp" />
                    <span>Whatsapp</span>
                  </SubMenuItem>
                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath === "/tags"}
                    onClick={() => handleClick("/tags")}
                  >
                    <i className="las la-tags" />
                    <span>Tags</span>
                  </SubMenuItem>
                  <SubMenuItem
                    expanded={expanded}
                    active={currentPath === "/business-settings"}
                    onClick={() => handleClick("/business-settings")}
                  >
                    <i className="las la-briefcase"></i>
                    <span>Meu negócio</span>
                  </SubMenuItem>
                </SubMenuContainer>
              )}
              <Col
                className="fs-13 text-center"
                style={{
                  position: "absolute",
                  bottom: 5,
                  color: "var(--primary)",
                }}
              >
                v.2.0
              </Col>
            </MenuSection>
          </>
        )}
      </Sidebar>

      <HeaderContainer sidebarWidth={sidebarWidth}>
        <Button
          className="bg-tertiary sharp mr-2 d-flex"
          style={{
            width: 35,
            height: 35,
            minWidth: 35,
            minHeight: 35,
            borderRadius: "100%",
            background:
              "linear-gradient(135deg, rgb(0, 123, 255), rgb(0, 86, 179))",
          }}
        >
          <IconBellFilled
            size={20}
            className="icon-changelog text-white"
            stroke={2}
            data-sleek
          />
        </Button>
        <Dropdown className="nav-item dropdown header-profile" as="li">
          <Dropdown.Toggle
            as="a"
            variant=""
            className="nav-link i-false p-0 c-pointer pointr position-relative"
          >
            <img
              src={
                user?.user_photo
                  ? Hash("75x75", user?.user_photo.replaceAll('"', ""))
                  : require("../../../images/user.png")
              }
              width={20}
              alt="profile"
            />
            <div className="header-info">
              <span className="text-black">{user?.first_name || ""}</span>
              <p className="text-black-50 fs-12 mb-0 ">
                {superuser[user?.superuser_level] || ""}
              </p>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu align="right" className="mt-2">
            <Link
              to={`/user-details/${user?.user_id || ""}`}
              className="dropdown-item ai-icon"
            >
              <svg
                id="icon-user1"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary"
                width={18}
                height={18}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx={12} cy={7} r={4} />
              </svg>
              <span className="ml-2">Perfil</span>
            </Link>

            <Link to="#" onClick={Logout} className="dropdown-item ai-icon">
              <svg
                id="icon-logout"
                xmlns="http://www.w3.org/2000/svg"
                className="text-danger"
                width={18}
                height={18}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1={21} y1={12} x2={9} y2={12} />
              </svg>
              <span className="ml-2">Sair</span>
            </Link>
          </Dropdown.Menu>
        </Dropdown>
      </HeaderContainer>
    </MainContainer>
  );
};

export default Header;
